/**
 * Text With Icons Carousel Component
 * Simple carousel for text-with-icons section
 */
if (!window.customElements.get("text-with-icons-carousel")) {
  class TextWithIconsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.items = [];
      this.navButtons = [];
    }

    connectedCallback() {
      // Check if disabled on current breakpoint
      const disabledOn = this.getAttribute("disabled-on");
      if (disabledOn === "sm" && window.innerWidth >= 700) {
        // Desktop - show all items
        this.items = Array.from(this.querySelectorAll(".text-with-icons__item"));
        this.items.forEach((item) => {
          item.style.display = "";
        });
        return;
      }

      this.items = Array.from(this.querySelectorAll(".text-with-icons__item"));

      if (this.items.length === 0) return;

      // Find navigation buttons
      const carouselId = this.getAttribute("id");
      if (carouselId) {
        const navContainer = document.querySelector(`.carousel-navigation[aria-controls="${carouselId}"]`);
        if (navContainer) {
          this.navButtons = Array.from(navContainer.querySelectorAll("button"));
        }
      }

      // Show first item
      this.goToSlide(0);

      // Handle swipe if enabled
      if (this.hasAttribute("allow-swipe")) {
        this.setupSwipe();
      }

      // Setup navigation
      this.setupNavigation();
    }

    setupSwipe() {
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      this.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      });

      this.addEventListener("touchmove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
      });

      this.addEventListener("touchend", (e) => {
        if (!isDragging) return;
        isDragging = false;

        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const diffX = startX - endX;
        const diffY = startY - endY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
          if (diffX > 0) {
            this.next();
          } else {
            this.previous();
          }
        }
      });
    }

    setupNavigation() {
      // Listen for clicks on navigation buttons
      this.navButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
          this.goToSlide(index);
        });
      });

      // Listen for clicks on items to navigate (optional)
      this.items.forEach((item, index) => {
        item.addEventListener("click", () => {
          this.goToSlide(index);
        });
      });
    }

    goToSlide(index) {
      if (index < 0 || index >= this.items.length) return;

      this.items.forEach((item, i) => {
        if (i === index) {
          item.classList.add("is-selected");
          item.style.display = "";
          item.style.opacity = "1";
        } else {
          item.classList.remove("is-selected");
          item.style.opacity = "0";
          setTimeout(() => {
            if (!item.classList.contains("is-selected")) {
              item.style.display = "none";
            }
          }, 300);
        }
      });

      // Update navigation buttons
      this.navButtons.forEach((button, i) => {
        if (i === index) {
          button.setAttribute("aria-current", "true");
        } else {
          button.setAttribute("aria-current", "false");
        }
      });

      this.currentIndex = index;
    }

    next() {
      const nextIndex =
        this.currentIndex + 1 >= this.items.length ? 0 : this.currentIndex + 1;
      this.goToSlide(nextIndex);
    }

    previous() {
      const prevIndex =
        this.currentIndex - 1 < 0 ? this.items.length - 1 : this.currentIndex - 1;
      this.goToSlide(prevIndex);
    }
  }

  window.customElements.define("text-with-icons-carousel", TextWithIconsCarousel);
}

